import { ShipperSlider } from '@/components/ShipperSlider'
import { SliderPanelLayout } from '@/components/SliderPanelLayout'

import { NmfcSearchContent } from './NmfcSearchContent'
import type { OnSelectArgs } from './types'

type Props = {
  initialSearch?: string
  density?: number
  open: boolean
  onClose: () => void
  onSelect: (args: OnSelectArgs) => void
}

export const NmfcSearchPanel = ({
  open,
  onClose,
  onSelect,
  initialSearch,
  density,
}: Props) => {
  return (
    <ShipperSlider isOpen={open} onClose={onClose}>
      <SliderPanelLayout
        title="Find the correct NMFC"
        titleClass="!mb-0 !pb-0 relative z-20"
        className="!h-auto"
        noBorder
      >
        {open && (
          <NmfcSearchContent
            initialSearch={initialSearch}
            density={density}
            onSelect={onSelect}
          />
        )}
      </SliderPanelLayout>
    </ShipperSlider>
  )
}
